import script from "./UserContact.vue?vue&type=script&setup=true&lang=js"
export * from "./UserContact.vue?vue&type=script&setup=true&lang=js"

import "./UserContact.vue?vue&type=style&index=0&id=5c0d08da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c0d08da"]])

export default __exports__